import { createContext, Dispatch, SetStateAction } from 'react';

import { ModalState } from './hook';

export type ModalContextProps = [ModalState | null, Dispatch<SetStateAction<ModalState | null>>];

export const ModalContext = createContext<ModalContextProps | []>([]);
